/**
 * Angular imports.
 */
import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';

/**
 * Service imports.
 */
import { MasterserviceService } from '../../../dataservices/master-service/masterservice.service';
import { FunCollectionService } from '../../common-functions/fun-collection.service';
import { GetService } from '../../../dataservices/get.service';
import { JwtDecodeService } from '../../../dataservices/jwt-decode.service';
import { NewLanguageService } from '../../../dataservices/new-language/new-language.service';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';

/**
 * Verification Under Process Component
 */
@Component({
  selector: 'app-verification-under-process',
  templateUrl: './verification-under-process.component.html',
  styleUrls: ['./verification-under-process.component.scss']
})
export class VerificationUnderProcessComponent implements OnDestroy {
  @Input() dataObj;
  @Input() callingfrom;

  @Output() emitButtonClicked: EventEmitter<null> = new EventEmitter();
  public displayObj = {
    isShow: false,
    display_section: '',
    data: [],
    errObj: []
  };

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * Necessary instance
   */
  constructor(
    private masterSer: MasterserviceService,
    private fcs: FunCollectionService,
    private getSer: GetService,
    private jwtSer: JwtDecodeService,
    public mls: NewLanguageService) { }

  /**
   * get Verification Status
   */
  getVerificationStatus(): void {
    this.emitButtonClicked.emit();
    this.subscriptions.add(this.getSer.verificationUnderProcess().subscribe(resData => {
      this.jwtSer.decodeData(resData).then(data => {
        if (data['status'] == 1) {
          if (data['code'] == 2000) {
            this.displayObj.isShow = true;
            this.displayObj.display_section = 'verificationSuccess';
            this.displayObj.data = data['data'];
            this.displayObj.errObj = [];
            this.masterSer.showWebModal.next(this.displayObj);
          }
        } else {
          this.fcs.errorHandeler(data);
          return;
        }
      });
    }));
  }

  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
